import { Dialog, Sheet } from "@gravity-ui/uikit";

import { PromotionContent } from "../PromotionContent";

interface PromotionSheetProps {
  open: boolean;
  onClose: () => void;
}

export const PromotionSheet = ({ open, onClose }: PromotionSheetProps) => {
  return (
    <Sheet visible={open} onClose={onClose}>
      <Dialog.Body>
        <PromotionContent />
      </Dialog.Body>
    </Sheet>
  );
};
